var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDot = function SvgDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 74,
    fill: "none",
    viewBox: "0 0 94 74"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0851",
    d: "M21.826 0q9.672 0 15.377 6.478 5.705 6.727 5.705 19.435 0 15.198-9.921 28.403Q23.066 67.772 0 74v-2.492q7.44-2.49 13.393-5.73t9.673-7.973q3.472-4.484 3.472-11.462 0-5.73-2.232-8.471a15.2 15.2 0 0 0-5.456-4.236 83 83 0 0 1-6.697-3.239q-3.225-1.494-5.456-4.484-2.233-2.991-2.233-8.97 0-8.97 5.209-12.956Q14.633 0 21.826 0M72.67 0q9.673 0 15.626 6.478Q93.999 13.205 94 25.913q0 15.198-9.92 28.403Q74.157 67.772 51.091 74v-2.492q7.193-2.49 13.394-5.73 5.952-3.24 9.672-7.973 3.473-4.484 3.473-11.462 0-5.73-2.233-8.471-2.48-2.74-5.704-4.236a59 59 0 0 1-6.449-3.239q-3.224-1.494-5.456-4.484-2.48-2.991-2.48-8.97 0-8.97 5.208-12.956Q65.725 0 72.67 0"
  })));
};
export default SvgDot;